import {List, ListItem} from '@luminopia/react-toolbox/lib/list'
import {IPrescriptionData} from 'core/api/patient'
import {RawJsonDialog} from 'core/components/json/raw-json-dialog'
import {msToMinutes} from 'core/utils/time-helpers'
import * as React from 'react'
import * as styles from './prescription-details.css'

interface IProps {
  className?: string
  prescription: IPrescriptionData
  showJson?: boolean
  onOpenJson?: () => void
  onCloseJson?: () => void
}

export class PrescriptionDetails extends React.PureComponent<IProps, {}> {
  public render() {
    const {prescription} = this.props

    let activeMessage = prescription.isActive ? 'Active' : 'Inactive'
    if (prescription.activationNotes) {
      activeMessage += ` (${prescription.activationNotes})`
    }

    return (
      <div className={styles.container}>
        <List>
          <ListItem
            caption={activeMessage}
            leftIcon={prescription.isActive ? 'done' : 'highlight_off'}
            ripple={false}
          />
          <ListItem
            legend='prescribers npi'
            caption={prescription.prescribingNpi || 'N/A'}
            leftIcon='medical_information'
            ripple={false}
          />
          <ListItem
            legend='start time'
            caption={prescription.activatedTime || 'N/A'}
            leftIcon='schedule'
            ripple={false}
          />
          <ListItem
            legend='amblyopic eye'
            caption={prescription.amblyopicEye}
            leftIcon='visibility'
            ripple={false}
          />
          <ListItem
            legend='daily dosage'
            caption={`${msToMinutes(prescription.dailyDosage)} minutes`}
            leftIcon='today'
            ripple={false}
          />
          <ListItem
            legend='treatment days per week'
            caption={`${prescription.daysPerWeekDosage} days`}
            leftIcon='date_range'
            ripple={false}
          />
        </List>
        <RawJsonDialog
          showJson={this.props.showJson}
          onCloseJson={this.props.onCloseJson}
          onOpenJson={this.props.onCloseJson}
          json={prescription}
        />
      </div>
    )
  }
}

interface IState {
  showJson: boolean
}

export class UncontrolledPrescriptionDetails extends React.Component<IProps, {}> {
  public state = {
    showJson: false,
  }

  public render() {
    return <PrescriptionDetails
      onOpenJson={this.setShowJson}
      onCloseJson={this.resetShowJson}
      showJson={this.state.showJson}
      {...this.props}
    />
  }

  private setShowJson = () => {
    this.setState({showJson: true})
  }

  private resetShowJson = () => {
    this.setState({showJson: false})
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/prescription/prescription-details.tsx